import { render, staticRenderFns } from "./Poliza.vue?vue&type=template&id=c75185fe"
import script from "./Poliza.vue?vue&type=script&lang=js"
export * from "./Poliza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports